export default __webpack_public_path__ + "static/2-287064b5a07a1dce6f611401ab875c83.webp";